import { LibraryBig } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const LibraryBigIcon = createLucideIcon(LibraryBig);
